<div container>
  <div class="hcp__headline__container d-flex align-items-center justify-content-lg-center">
    <div class="headline-text-box">
      <h2 class="mb-0">Patient resources</h2>
    </div>
  </div>
  <div class="hcp__cards__container justify-content-center mx-auto">
    <div class="card card--aqua bg-white d-flex flex-column flex-lg-row">
      <div class="card__image card__image--1 flex-shrink-0 align-self-center">
        <picture [data]=" {
            image: 'resources/paper-stack',
            webp: false,
            altext: 'A Type 1 Diabetes (T1D) doctor discussion guide',
            format: '',
            width: '100',
            height: '126',
            mobile: false,
            classes: 'img-fluid',
          }"></picture>
      </div>
      <div class="card__text-box d-flex flex-column">
        <div>
          <h3 class="text-center text-lg-start">Doctor Discussion Guide</h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            Autoantibodies. Stages. Potential risks and benefits. Let's face it:
            There's a lot to remember about type 1 diabetes and screening, and
            patients may have questions for their doctors. This discussion guide
            can help support a useful conversation.
          </p>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0 d-lg-none">
          <div global-button [buttonData]="{
                  buttonLabel: 'Download',
                  buttonUrl: '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
                  openInNewTab: true,
                  buttonIcon: 'download-icon',
                  interstitial: false
                }"></div>
        </div>
        <div class="card--1__button mt-auto mx-auto mx-lg-0 d-none d-lg-block">
          <div global-button [buttonData]="{
                  buttonLabel: 'Download',
                  buttonUrl: '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide.pdf',
                  openInNewTab: true,
                  buttonIcon: 'download-icon',
                  interstitial: false
                }"></div>
        </div>
      </div>
    </div>
    <div class="card card--yellow bg-white d-flex flex-column flex-lg-row">
      <div class="card__image card__image--2 flex-shrink-0 align-self-center">
        <picture [data]=" {
              image: 'resources/magni-2-icon',
            webp: false,
            altext: 'A magnifying glass looking at autoantibodies',
            format: '',
            width: '102',
            height: '81',
            mobile: false,
            classes: 'img-fluid',
          }"></picture>
      </div>
      <div class="card__text-box d-flex flex-column">
        <div>
          <h3 class="text-center text-lg-start">Screening Quick Start</h3>
          <p class="mb-lg-4 mb-3 text-center text-lg-start">
            There are a number of ways to get screened: at participating labs,
            at the office, or using an at-home kit. This guide lays out how
            providers and patients can access screening.
          </p>
        </div>

        <div class="card--2__button mt-auto mx-auto mx-lg-0 d-lg-none">
          <div global-button [buttonData]="{
                  buttonLabel: 'Download',
                  buttonUrl: '/assets/pdf/type-1-diabetes-screening-quick-start-guide-mobile.pdf',
                  openInNewTab: true,
                  buttonIcon: 'download-icon',
                  interstitial: false
                }"></div>
        </div>

        <div class="card--2__button mt-auto mx-auto mx-lg-0 d-none d-lg-block">
          <div global-button [buttonData]="{
                  buttonLabel: 'Download',
                  buttonUrl: '/assets/pdf/type-1-diabetes-screening-quick-start-guide.pdf',
                  openInNewTab: true,
                  buttonIcon: 'download-icon',
                  interstitial: false
                }"></div>
        </div>
      </div>
    </div>
  </div>
</div>
